module.exports = __webpack_public_path__ + "img/share.58d2cbd7.png";